module.exports = __webpack_public_path__ + "static/img/1.d293ac7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/sp/1.png
// module id = 8jE3
// module chunks = 0